<template>
  <div id="app" style="height:100%;text-align: left;">
    <transition name="slide">
      <keep-alive>
        <router-view :key="$route.fullPath" v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </transition>
    <transition name="slide">
      <router-view :key="$route.fullPath" v-if="!$route.meta.keepAlive"></router-view>
    </transition>
  </div>
</template>
<script>
    import store from "./store";
    export default {
        data(){
            return{
            }
        },
        methods:{
            font(){
                let clientWidth = document.documentElement.clientWidth;
                document.documentElement.style.fontSize = clientWidth / 19.2 + 'px';
                window.onresize = function temp() {
                    let clientWidth = document.documentElement.clientWidth;
                    document.documentElement.style.fontSize = clientWidth / 19.2 + 'px';
                };
            },
        },
        created(){
        },
        mounted(){
            this.font();
        },
    }
</script>
<style>
  #app {
    height: 100%;
  }
 body .el-message-box{
  	border: none;
  }
  body .el-message-box__header {
      background-color: #137DD8;
  }
 body .el-message-box__headerbtn .el-message-box__close{
  	color: white;
  }
  body .el-message-box__title{
  	color: white;
  }
   body .el-message-box__content{
  	padding: 30px 15px;
  	color: #333333;
  }
  
  .el-table--border th.gutter:last-of-type {
      display: block!important;
      width: 17px!important;
  }
  .el-table{
    font-size:12px!important;
  }
  .el-table thead th {
    font-size: 14px!important;
  }
  .red-bg {
    background: #ff0000;
  }
</style>
